<template>
  <div>
    <el-row>
      <el-col :xs="24" :sm="24" :md="4" :lg="4" :xl="4">
        <div class="header header-left" style="width: 300px">
          <el-select
            v-model="globalFieldSiteId"
            :placeholder="i18nValues['fieldSite']"
            style="margin-right: 20px;"
            @change="onFieldSiteChange"
          >
            <el-option
              v-for="item in fieldSites"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
          <el-select
            v-model="globalCampaignId"
            :placeholder="i18nValues['campaign']"
            :clearable="false"
            @change="onCampaignChange"
          >
            <el-option
              v-for="item in campaigns"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
      </el-col>
      <el-col :xs="24" :sm="24" :md="10" :lg="10" :xl="10" :offset="10">
  <div class="header header-right">
    <div class="export-section" v-if="profileComponentsMap.get('consolidated_menu')">
      <el-button
        size="mini"
        plain
        @click="exportConsolidated"
        class="export-consolidated-btn"
        icon="el-icon-download"
      >
        <span class="btn-text-full">{{ i18nValues["consolidatedHistory"] || "Historial Consolidado" }}</span>
        <span class="btn-text-short">{{ i18nValues["consolidated"] || "Consolidado" }}</span>
        <svg class="flag-icon" viewBox="0 0 60 30">
          <rect width="60" height="30" fill="#B22234"/>
          <rect y="3.5" width="60" height="3.5" fill="white"/>
          <rect y="10.5" width="60" height="3.5" fill="white"/>
          <rect y="17.5" width="60" height="3.5" fill="white"/>
          <rect y="24.5" width="60" height="3.5" fill="white"/>
          <rect width="24" height="17.5" fill="#3C3B6E"/>
        </svg>
      </el-button>
    </div>
    <div class="language-section">
      <el-select
        v-model="selectedLanguage"
        @change="onLanguageChange"
        :placeholder="i18nValues['language']"
        class="language-select"
        size="mini"
      >
        <el-option
          v-for="item in languages"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        >
        </el-option>
      </el-select>
    </div>
    <div class="user-section">
      <span class="username username-id" v-if="user">{{ this.identification ? this.identification : user.identification }}</span>
      <span class="username username-name" v-if="user">{{ user.name }}</span>
      <el-dropdown class="drop" trigger="click" @command="handleCommand">
        <el-avatar size="small" icon="el-icon-user-solid"></el-avatar>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="exit">
            <i class="fas fa-power-off"></i>
            {{ i18nValues["getOut"] }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</el-col>

    </el-row>
  </div>
</template>

<script>
var VueCookie = require("vue-cookie");
import auth from "@/mixins/auth.js";

export default {
  name: "TopBar",
  mixins: [auth],
  components: {},
  props: {
    msg: String,
    fieldSites: {
      type: Array,
      required: true,
    },
    campaigns: {
      type: Array,
      required: true,
    },
    languages: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      globalFieldSiteId: null,
      globalCampaignId: null,
      componentKey: 0,
      filteredCampaigns: [],
      identification: null,
      selectedLanguage: null,
      initialPhase: true,
      initializedSelectionsOnce: false,
      userChangedFieldSite: false,
      userChangedCampaign: false
    };
  },
  computed: {
    i18nValues() {
      return this.$store.state.i18nStore.valuesRetrieved || {};
    },
    user() {
      return this.$store.state.authentication.user;
    }
  },
  mounted() {
    const savedLanguage = VueCookie.get("selectedLanguage");
    if (savedLanguage) {
      this.selectedLanguage = savedLanguage;
    } else if (this.languages.length > 0) {
      this.selectedLanguage = this.languages[0].id;
    }
  },
  created() {
    // Build the components map for permission checking
    this.buildComponentsMap();
    // Mark end of initial phase on next tick after mount lifecycle begins
    this.$nextTick(() => {
      this.initialPhase = false;
    });
  },
  watch: {
    "$route": {
      handler(to) {
        // Sync TopBar selects when URL changes (e.g. manual URL edit + Enter)
        const fieldSiteId = to && to.query && to.query.fieldSiteId ? Number(to.query.fieldSiteId) : null;
        const campaignId = to && to.query && to.query.campaignId ? Number(to.query.campaignId) : null;
        if (fieldSiteId && !isNaN(fieldSiteId) && fieldSiteId !== this.globalFieldSiteId) {
          this.globalFieldSiteId = fieldSiteId;
        }
        if (campaignId && !isNaN(campaignId) && campaignId !== this.globalCampaignId) {
          this.globalCampaignId = campaignId;
        }
      },
    },
    userProfiles: {
      handler() {
        // Rebuild the components map when user profiles change
        this.buildComponentsMap();
      },
      immediate: true,
    },
    globalFieldSiteId: {
      handler(newSiteId) {
        // Immediately signal the new ID so downstream watchers (e.g. FieldSection)
        // can invalidate in-flight requests before the full object arrives from the API.
        if (newSiteId) {
          this.$store.commit("updateGlobalFieldSite", { id: newSiteId });
        }
        this.$store
          .dispatch("fieldSite/retrieveFieldSiteById", newSiteId)
          .then((res) => {
            this.$store.commit("updateGlobalFieldSite", res);
          });

        if (newSiteId) {
          VueCookie.set("globalFieldSiteId", newSiteId);
        }

        if (this.globalFieldSiteId && this.globalCampaignId) {
          if (!this.initializedSelectionsOnce) {
            this.initializedSelectionsOnce = true;
          } else if (this.userChangedFieldSite) {
            this.navigateToDashboard(true);
            this.userChangedFieldSite = false;
          }
        }
      },
      immediate: true,
    },
    globalCampaignId: {
      handler(newCampaignId) {
        this.$store
          .dispatch("campaign/retrieveCampaignById", { id: newCampaignId })
          .then((res) => {
            this.$store.commit("updateGlobalCampaign", res);
          });

        if (newCampaignId) {
          VueCookie.set("globalCampaignId", newCampaignId);
        }

        if (this.globalFieldSiteId && this.globalCampaignId) {
          if (!this.initializedSelectionsOnce) {
            this.initializedSelectionsOnce = true;
          } else if (this.userChangedCampaign) {
            this.navigateToDashboard(true);
            this.userChangedCampaign = false;
          }
        }
      },
      immediate: true,
    },

    fieldSites: {
      immediate: true,
      handler() {
        if (this.fieldSites.length > 0) {
          this.initializeFromCookies();
          if (this.globalFieldSiteId === null) {
            this.globalFieldSiteId =
              this.fieldSites[0] && this.fieldSites[0].id
                ? this.fieldSites[0].id
                : null;
          }
        }
      },
    },
    campaigns: {
      immediate: true,
      handler() {
        if (this.campaigns.length > 0) {
          this.initializeFromCookies();
          if (this.globalCampaignId === null) {
            this.globalCampaignId =
              this.campaigns[0] && this.campaigns[0].id
                ? this.campaigns[0].id
                : null;
          }
        }
      },
    }
  },
  methods: {
    exportConsolidated() {
      const globalCampaign = this.$store.state.globalCampaign;
      const selectedLanguage = this.$store.state.i18nStore.selectedLanguage;
      
      const filter = {
        selectedLanguage: selectedLanguage,
        campaignId: globalCampaign ? globalCampaign.id : null,
      };

      this.$store.dispatch("exportXls/exportConsolidated", filter).then((res) => {
        const blob = new Blob([res], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        
        const campaignName = globalCampaign && (globalCampaign.name || globalCampaign.code || globalCampaign.id)
          ? (globalCampaign.name || globalCampaign.code || globalCampaign.id)
          : "Sin_campana";
        const dateStr = new Date().toISOString().split("T")[0];
        const desiredName = `Historial_Consolidado_USA_${campaignName}_${dateStr}.xlsx`;
        
        link.download = desiredName.replace(/\s+/g, "_");
        link.click();
        URL.revokeObjectURL(link.href);
      }).catch(() => {
        this.$message.error("Error al exportar el historial consolidado");
      });
    },
    onLanguageChange(newLanguageId) {
      // Clear the store before switching to force fresh load
      this.$store.commit("i18nStore/SET_VALUES_RETRIEVED", {});
      VueCookie.set("selectedLanguage", newLanguageId);
      // Wait for the language change, then reload
      this.$store.dispatch("i18nStore/changeI18n", newLanguageId).then(() => {
        this.$router.go(0);
      });
    },
    onFieldSiteChange() {
      this.userChangedFieldSite = true;
    },
    onCampaignChange() {
      this.userChangedCampaign = true;
    },
    handleCommand(command) {
      if (command == "exit") {
        this.$cookie.delete("pc_authentication");
        this.$cookie.delete("pc_identification");
        this.identification = "";
        this.$router.push({ name: "login" });
      }
    },
    navigateToDashboard(force = false) {
      const currentName = this.$router && this.$router.currentRoute
        ? this.$router.currentRoute.name
        : null;
      const hash = typeof window !== 'undefined' && window.location ? window.location.hash : '';
      const hasDeepLink = !!hash && hash !== '#' && hash !== '#/' ;
      // Only auto-navigate on initial/landing contexts to avoid overriding deep links
      if (force) {
        this.$router.push({ name: "Dashboard" });
        return;
      }
      if (!hasDeepLink && (currentName === null || currentName === undefined || currentName === "login" || currentName === "error")
        && currentName !== "Dashboard") {
        this.$router.push({ name: "Dashboard" });
      }
    },
    initializeFromCookies() {
      const savedFieldSiteId = VueCookie.get("globalFieldSiteId");
      const savedCampaignId = VueCookie.get("globalCampaignId");
      this.identification = VueCookie.get("pc_identification")
        ? JSON.parse(VueCookie.get("pc_identification"))
        : null;

      if (savedFieldSiteId && !isNaN(Number(savedFieldSiteId))) {
        this.globalFieldSiteId = Number(savedFieldSiteId);
        this.$store
          .dispatch("fieldSite/retrieveFieldSiteById", this.globalFieldSiteId)
          .then((res) => {
            this.$store.commit("updateGlobalFieldSite", res);
          });
      }

      if (savedCampaignId && !isNaN(Number(savedCampaignId))) {
        this.globalCampaignId = Number(savedCampaignId);
        this.$store
          .dispatch("campaign/retrieveCampaignById", {
            id: this.globalCampaignId,
          })
          .then((res) => {
            this.$store.commit("updateGlobalCampaign", res);
          });
      }
    },
  },
};
</script>

<style>
.header {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  align-content: center;
  padding-top: 9.5px;
}
.header-left {
  justify-content: flex-start;
  padding-left: 32px;
}
.header-right {
  justify-content: flex-end;
  padding-right: 32px;
  gap: 20px;
}

/* Section containers */
.export-section {
  display: flex;
  align-items: center;
}

.language-section {
  display: flex;
  align-items: center;
}

.user-section {
  display: flex;
  align-items: center;
  gap: 10px;
}

.username {
  margin-right: 10px;
  display: inline-block;
  position: relative;
  color: #606266;
  font-size: 16px;
  margin-bottom: 7px;
}

/* Export button styling */
.export-consolidated-btn {
  background-color: white;
  border: 1px solid #dcdfe6;
}

.flag-icon {
  width: 16px;
  height: 11px;
  margin-left: 4px;
  vertical-align: middle;
}

.language-select .el-input__inner {
  width: 120px;
}

.language-select .el-input.is-focus .el-input__inner {
  border-color: #019e5a;
}

/* Show full text by default */
.btn-text-full {
  display: inline;
}
.btn-text-short {
  display: none;
}

@media (max-width: 1100px) {
  /* Hide export button on smaller screens to give more room */
  .export-section {
    display: none !important;
  }
  .header-right {
    gap: 15px;
  }
}

@media (max-width: 991px) {
  .header-right {
    gap: 12px;
  }
  .username-id {
    display: none !important;
  }
}

/* Mobile layout adjustments */
@media (max-width: 767px) {
  .header-left,
  .header-right {
    padding-left: 10px;
    padding-right: 10px;
    justify-content: center;
    gap: 10px;
  }
  .username {
    font-size: 13px;
    margin-right: 5px;
  }
}

@media (max-width: 576px) {
  .header-right {
    gap: 8px;
  }
  .username-name {
    display: none !important;
  }
}
</style>
